export default __webpack_public_path__ + "static/media/test-tubes-generic-map.d09f7738.gif";